import script from "./OrderResult.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderResult.vue?vue&type=script&setup=true&lang=js"

import "./OrderResult.vue?vue&type=style&index=0&id=79c9da52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c9da52"]])

export default __exports__